RivalIQ.module('export.models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    const DownloadedReport = models.DownloadedReport = models.Report.extend({
        url: function () {
            const me = this;
            return `/api/landscapes/${me.get('landscapeId')}/report/download`;
        },

        action: RivalIQ.export.type.DOWNLOAD,

        exportSuccessMsg: 'We are busy creating your report. The download should begin shortly.',

        exportErrorMsg: 'We had an issue exporting your report.  Please try again.',

        dialogRequired: function () {
            return false;
        },

        _downloadFile: function () {
            const me = this;

            const iOS = (/(iPad|iPhone|iPod)/g).test(navigator.userAgent);
            const android = (/(Android)/g).test(navigator.userAgent);
            const windowsPhone = (/(Windows Phone)/g).test(navigator.userAgent);

            let url = `/r/${me.get('uuid')}?auto=true`;

            const width = me.get('width');
            if (width) {
                url += `&width=${width}`;
            }

            const zoom = me.get('zoom');
            if (zoom) {
                url += `&zoom=${zoom}`;
            }

            // mobile browsers ignore the 'attachment:filename' that causes desktop clients to download the file,
            // so if the user agent suggests this is a mobile device, open the url in a new tab instead.
            if (iOS || android || windowsPhone) {
                window.open(url, '_blank');
            } else {
                const iframe = document.createElement('iframe');

                iframe.style.display = 'none';
                iframe.src = url;

                $('body').append(iframe);
            }
        },

        _handleStatusChange: function () {
            const me = this;

            if (me.isDone() || me.isFailed()) {
                me.off('change:export_status_id');

                if (me.isDone()) {
                    me._downloadFile();
                }
            }
        },

        initialize: function (attrs, options) {
            const me = this;

            models.Report.prototype.initialize.apply(me, arguments);

            if (options.downloadIfDone) {
                me._handleStatusChange();
            }

            me.on('change:export_status_id', me._handleStatusChange, me);
        }
    });

    DownloadedReport.action = RivalIQ.export.type.DOWNLOAD;
});
